module.exports = __webpack_public_path__ + "static/media/anissa.4f8ddd04.jpg";